var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"plus":""}},[_c('div',{attrs:{"plus-inner":""}},[_c('div',{attrs:{"plus-padding":""}},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.plusBtn}},[_c('Icon',{attrs:{"name":"plus"}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }